import { render, staticRenderFns } from "./Uniswap.vue?vue&type=template&id=2d3bd589&scoped=true&"
import script from "./Uniswap.vue?vue&type=script&lang=js&"
export * from "./Uniswap.vue?vue&type=script&lang=js&"
import style0 from "./Uniswap.vue?vue&type=style&index=0&id=2d3bd589&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bd589",
  null
  
)

export default component.exports